import { StoreState } from "../../store";

const selector = (state: StoreState) => state.road;

export const roadSelectors = {};
